export { AccordionGroup, type AccordionGroupProps } from './AccordionGroup';
